import { LoaderCircle } from "lucide-react";
function Loader() {
  return <LoaderCircle className="animate-spin text-indigo-600" size={48} />;
}

export default Loader;
